import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { useAuth } from './contexts/AuthContext';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import PostgreSQL from './pages/PostgreSQL';
import Kubernetes from './pages/Kubernetes';
import Alerts from './pages/Alerts';
import DatabaseInstances from './pages/DatabaseInstances';
import DatabaseUsers from './pages/DatabaseUsers';
import UserManagement from './pages/UserManagement';

import Layout from './components/Layout';
import LoadingSpinner from './components/LoadingSpinner';

const App: React.FC = () => {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <LoadingSpinner />
      </div>
    );
  }

  if (!user) {
    return <Login />;
  }

  return (
    <Layout>
      <Routes>
        <Route path="/" element={<Navigate to="/dashboard" replace />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/postgresql" element={<PostgreSQL />} />
        <Route path="/kubernetes" element={<Kubernetes />} />
        <Route path="/alerts" element={<Alerts />} />
        <Route path="/database-instances" element={<DatabaseInstances />} />
        <Route path="/database-users" element={<DatabaseUsers />} />
        <Route path="/user-management" element={<UserManagement />} />
        <Route path="*" element={<Navigate to="/dashboard" replace />} />
      </Routes>
    </Layout>
  );
};

export default App; 